<!--<div title="Ice cream for {{item.username}}">-->
<!--  <i class="fas fa-ice-cream"></i>-->
<!--</div>-->

IT WORKS
